var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bm-empty"},[_c('v-icon',{attrs:{"size":"40","color":"grey lighten-1"}},[_vm._v(_vm._s(_vm.icon))]),_c('div',{staticClass:"subtitle-1 font-weight-medium mt-1"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"bm-tiny",staticStyle:{"max-width":"520px"}},[_vm._v(_vm._s(_vm.text))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }